/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CurrencyRateResponseDto
 */
export interface CurrencyRateResponseDto {
    /**
     * 
     * @type {string}
     * @memberof CurrencyRateResponseDto
     */
    currencyRateId: string;
    /**
     * 
     * @type {string}
     * @memberof CurrencyRateResponseDto
     */
    currencyCode: string;
    /**
     * 
     * @type {string}
     * @memberof CurrencyRateResponseDto
     */
    rateToUSD?: string;
}

/**
 * Check if a given object implements the CurrencyRateResponseDto interface.
 */
export function instanceOfCurrencyRateResponseDto(value: object): value is CurrencyRateResponseDto {
    if (!('currencyRateId' in value) || value['currencyRateId'] === undefined) return false;
    if (!('currencyCode' in value) || value['currencyCode'] === undefined) return false;
    return true;
}

export function CurrencyRateResponseDtoFromJSON(json: any): CurrencyRateResponseDto {
    return CurrencyRateResponseDtoFromJSONTyped(json, false);
}

export function CurrencyRateResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CurrencyRateResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'currencyRateId': json['currencyRateId'],
        'currencyCode': json['currencyCode'],
        'rateToUSD': json['rateToUSD'] == null ? undefined : json['rateToUSD'],
    };
}

export function CurrencyRateResponseDtoToJSON(json: any): CurrencyRateResponseDto {
    return CurrencyRateResponseDtoToJSONTyped(json, false);
}

export function CurrencyRateResponseDtoToJSONTyped(value?: CurrencyRateResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currencyRateId': value['currencyRateId'],
        'currencyCode': value['currencyCode'],
        'rateToUSD': value['rateToUSD'],
    };
}

